import React from 'react';
import { useDocumentManagement, DocumentAdminLink } from '../../features/legal/DocumentAdminAccess';
import LegalDocument from '../../features/legal/LegalDocument';
import AdminDocument from './AboutAdmin';
export default function About() {
  const managing = useDocumentManagement();
  return managing ? (
    <>
      <DocumentAdminLink editing />
      <AdminDocument />
    </>
  ) : (
    <LegalDocument type="about" />
  );
}
